import { urls } from './../../config';
import authFetch from './../../utils/authFetch';
import uploadFetch from './../../utils/uploadFetch';

export const USER_REQUEST = 'USER_REQUEST';
export const USER_RECEIVE = 'USER_RECEIVE';
export const USER_INVALIDATE = 'USER_INVALIDATE';
export const USER_TASKS_REQUEST = 'USER_TASKS_REQUEST';
export const USER_TASKS_RECEIVE = 'USER_TASKS_RECEIVE';

export const USER_SET_AVAILABLE_REQUEST = 'USER_SET_AVAILABLE_REQUEST';
export const USER_SET_AVAILABLE_RECEIVE = 'USER_SET_AVAILABLE_RECEIVE';

export const USER_SET_SUBJECTS_REQUEST = 'USER_SET_SUBJECTS_REQUEST';
export const USER_SET_SUBJECTS_RECEIVE = 'USER_SET_SUBJECTS_RECEIVE';

export const USER_SET_FIELD_REQUEST = 'USER_SET_FIELD_REQUEST';
export const USER_SET_FIELD_RECEIVE = 'USER_SET_FIELD_RECEIVE';
export const USER_SET_FIELD = 'USER_SET_FIELD';

export const USER_FILE_UPLOAD_REQUEST = 'USER_FILE_UPLOAD_REQUEST';
export const USER_FILE_UPLOAD_PROGRESS = 'USER_FILE_UPLOAD_PROGRESS';
export const USER_FILE_UPLOAD_RECEIVE = 'USER_FILE_UPLOAD_RECEIVE';

export const USER_ACTION_REQUEST = 'USER_ACTION_REQUEST';
export const USER_ACTION_RECEIVE = 'USER_ACTION_RECEIVE';

const userRequest = () => {
    return {
        type: USER_REQUEST
    };
};

const userReceive = user => {
    return {
        type: USER_RECEIVE,
        user
    };
};

const userFetch = () => {
    return dispatch => {
        dispatch(userRequest());
        return authFetch(urls.user).then(json => dispatch(userReceive(json)));
    };
};

const userShouldFetch = state => {
    const user = state.user;
    if (user.isFetching) {
        return false;
    } else {
        return user.didInvalidate;
    }
};

export const userFetchIfNeeded = () => {
    return (dispatch, getState) => {
        if (userShouldFetch(getState())) {
            return dispatch(userFetch());
        }
    };
};

const userTasksReceive = tasks => {
    return {
        type: USER_TASKS_RECEIVE,
        tasks
    };
};

const userTasksRequest = () => {
    return {
        type: USER_TASKS_REQUEST,
    };
};

const userTasksShouldFetch = state => {
    const tasks = state.user.tasks;
    if (!tasks) {
        return true;
    }
    if (tasks.isFetching) {
        return false;
    } else {
        return tasks.didInvalidate;
    }
};

const userTasksFetch = () => {
    return dispatch => {
        dispatch(userTasksRequest());
        return authFetch(urls.tasks).then(json => dispatch(userTasksReceive(json.results)));
    };
};

export const userTasksFetchIfNeeded = () => {
    return (dispatch, getState) => {
        if (userTasksShouldFetch(getState())) {
            return dispatch(userTasksFetch());
        }
    };
};

const userSetAvailableRequest = () => ({
    type: USER_SET_AVAILABLE_REQUEST
});

const userSetAvailableReceive = data => ({
    type: USER_SET_AVAILABLE_RECEIVE,
    data
});

export const userSetAvailableFetch = value => {
    return dispatch => {
        dispatch(userSetAvailableRequest());
        return authFetch(urls.user, {
            method: 'PATCH',
            body: JSON.stringify({
                available_for: value
            })
        }).then(data => dispatch(userSetAvailableReceive(data)));
    }
};

const userSetSubjectsRequest = subjects => ({
    type: USER_SET_SUBJECTS_REQUEST,
    subjects
});

const userSetSubjectsReceive = data => ({
    type: USER_SET_SUBJECTS_RECEIVE,
    data
});

export const userSetSubjectsFetch = subjects => {
    return dispatch => {
        dispatch(userSetSubjectsRequest(subjects));
        return authFetch(urls.user, {
            method: 'PATCH',
            body: JSON.stringify({
                subjects
            })
        }).then(data => dispatch(userSetSubjectsReceive(data)));
    };
};

const userSetFieldRequest = (name, value) => ({
    type: USER_SET_FIELD_REQUEST,
    name,
    value
});

const userSetFieldReceive = (name, data) => ({
    type: USER_SET_FIELD_RECEIVE,
    name,
    data
});

export const userSetFieldFetch = (name, value) => {
    return dispatch => {
        dispatch(userSetFieldRequest(name, value));
        return authFetch(urls.user, {
            method: 'PATCH',
            body: JSON.stringify({
                [name]: value
            })
        }).then(data => dispatch(userSetFieldReceive(name, data)));
    };
};

export const userSetField = (name, value) => ({
    type: USER_SET_FIELD,
    name,
    value
});

const userFileUploadRequest = (fileType, fileName) => ({
    type: USER_FILE_UPLOAD_REQUEST,
    fileType,
    fileName
});

const userFileUploadProgress = (fileType, progress) => ({
    type: USER_FILE_UPLOAD_PROGRESS,
    fileType,
    progress
});

const userFileUploadReceive = (fileType, data) => ({
    type: USER_FILE_UPLOAD_RECEIVE,
    fileType,
    data
});

export const userFileUploadFetch = (fileType, file) => {
    return (dispatch, getState) => {
        dispatch(userFileUploadRequest(fileType, file.name));
        const formData = new FormData();
        formData.append('type', fileType === 'passport_copy' ? 'writer_passport' : 'writer_residence');
        formData.append('files', file);
        return uploadFetch(urls.upload, formData, percent => dispatch(userFileUploadProgress(fileType, percent))).then(data => {
            const fileData = {
                name: data.results[0].file,
                location: data.results[0].location
            };
            dispatch(userFileUploadReceive(fileType, fileData));
            switch (fileType) {
                case 'passport_copy':
                    dispatch(userSetField('passport_verified', false));
                    break;
                case 'residence_copy':
                    dispatch(userSetField('profile_residence_verified', false));
                    break;
                default:
                    break;
            }
        });
    };
}

const userActionRequest = () => ({
    type: USER_ACTION_REQUEST
});

const userActionReceive = data => ({
    type: USER_ACTION_RECEIVE,
    data
});

export const userActionFetch = (data) => {
    return dispatch => {
        dispatch(userActionRequest());
        return authFetch(urls.user, {
            method: 'POST',
            body: JSON.stringify(data)
        }).then(data => dispatch(userActionReceive(data)));
    };
};



// WEBPACK FOOTER //
// ./src/store/user/actions.js